/** SetpageBand.jsx 와 동일한 용어/값 — coins_data_band 일괄 수정용 */

export const BAND_BULK_TABLE = "coins_data_band";
export const BAND_BULK_VERSION_LABEL = "밴드버전";

const ON_OFF = [
  { value: "1", label: "켜짐 (1)" },
  { value: "0", label: "꺼짐 (0)" },
];

const UT_KINPOINT = [
  { value: "ut", label: "시그널" },
  { value: "kinpoint", label: "킨포인트" },
];

const HEDGE_MODE = [
  ...UT_KINPOINT,
  { value: "none", label: "미적용" },
  { value: "losscut", label: "손절적용" },
];

const FULL_MODE = [
  { value: "extension", label: "즉시진입모드" },
  { value: "original", label: "변곡진입모드" },
];

const BOTH_MODE = [
  { value: "single", label: "single mode" },
  { value: "double", label: "double mode" },
];

const CANDLE = [
  { value: "5m", label: "5 분봉" },
  { value: "15m", label: "15 분봉" },
  { value: "30m", label: "30 분봉" },
  { value: "1h", label: "1 시간봉" },
  { value: "4h", label: "4 시간봉" },
  { value: "6h", label: "6 시간봉" },
  { value: "12h", label: "12 시간봉" },
  { value: "1d", label: "1 일봉" },
  { value: "3d", label: "3 일봉" },
  { value: "1w", label: "1 주봉" },
];

const CANDLE_TYPE = [
  { value: "haikin", label: "하이킨아시" },
  { value: "normal", label: "일반봉" },
];

const SIGNAL_CHECKING = [
  { value: "-1", label: "발생" },
  { value: "-2", label: "확정" },
];

const ABLE_DISABLE = [
  { value: "able", label: "적용" },
  { value: "disable", label: "미적용" },
];

const ENTRY_STANDARD = [
  { value: "ut", label: "시그널" },
  { value: "candle", label: "캔들" },
  { value: "ema", label: "EMA" },
  { value: "disable", label: "미적용" },
];

const HOLD_PRESERVE = [
  { value: "disable", label: "수수료보전" },
  { value: "able", label: "수익보전" },
  { value: "hybrid_fwd", label: "하이브리드(정)" },
  { value: "hybrid_rev", label: "하이브리드(역)" },
];

export function isBandHybridHoldMode(mode) {
  const m = String(mode || "").trim().toLowerCase();
  return m === "hybrid_fwd" || m === "hybrid_rev";
}

export function bandHoldShowsProfitRoi(mode) {
  const m = String(mode || "").trim().toLowerCase();
  return m === "able" || isBandHybridHoldMode(m);
}

const ENTRY_BASIS = [
  { value: "kinpoint", label: "킨포인트" },
  { value: "turtle", label: "터틀" },
];

const BAND_DCA_MODE = [
  { value: "disable", label: "미적용" },
  { value: "extreme", label: "극값" },
  { value: "kinpoint", label: "킨포인트" },
];

const ENTRY_EXTREME_AVG = [
  { value: "disable", label: "미적용" },
  { value: "apply", label: "적용" },
];

const DIRECTION = [
  { value: "long", label: "롱" },
  { value: "short", label: "숏" },
  { value: "auto", label: "자동전환" },
];

const HEDGE_CONTINUE = [
  { value: "no", label: "미적용" },
  { value: "ok", label: "적용" },
];

const TOTAL_CONTINUE_DIR = [
  { value: "both", label: "양방향" },
  { value: "long", label: "롱" },
  { value: "short", label: "숏" },
];

/** @type {Array<{ column: string, label: string, group: string, inputType?: string, options?: Array<{value:string,label:string}>, hideInBulkPicker?: boolean }>} */
const _BAND_FIELD_CATALOG = [
  { column: "uid", label: "UID", group: "계정/심볼", inputType: "text" },
  { column: "symbol", label: "심볼", group: "계정/심볼", inputType: "text" },
  { column: "normal_selected", label: "심볼 선택 여부", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "trade_start", label: "매매 시작", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "restart", label: "재시작", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "current_symbol_stop", label: "심볼 일시정지", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "current_symbol_cancle", label: "심볼 취소", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "long_entry", label: "롱 레그 상태", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "short_entry", label: "숏 레그 상태", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "continue_entry", label: "연속 진입(즉시)", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "add_position", label: "추가진입/헷지 단계", group: "매매 상태", inputType: "boolean", options: ON_OFF },
  { column: "both_mode", label: "Single/Double 모드", group: "매매 상태", inputType: "select", options: BOTH_MODE },
  { column: "direction", label: "진입 방향 선택", group: "매매 상태", inputType: "select", options: DIRECTION },
  { column: "entry_basis", label: "진입 기준(킨포인트/터틀)", group: "Basic setting", inputType: "select", options: ENTRY_BASIS },
  { column: "hedge_mode", label: "헷지기준", group: "Basic setting", inputType: "select", options: HEDGE_MODE },
  { column: "full_mode", label: "진입모드", group: "Basic setting", inputType: "select", options: FULL_MODE },
  { column: "entry_candle", label: "진입 기준봉", group: "Basic setting", inputType: "select", options: CANDLE },
  { column: "hedge_candle", label: "헷지 기준봉", group: "Basic setting", inputType: "select", options: CANDLE },
  { column: "candle_type_entry", label: "진입/헷지 기준 캔들", group: "Basic setting", inputType: "select", options: CANDLE_TYPE },
  { column: "candle_type_close", label: "익절 기준 캔들", group: "Basic setting", inputType: "select", options: CANDLE_TYPE },
  { column: "sensitivity", label: "LONG Sensitivity (진입)", group: "Basic setting", inputType: "number" },
  { column: "atr_period", label: "LONG ATR Period (진입)", group: "Basic setting", inputType: "number" },
  { column: "sensitivity_short", label: "SHORT Sensitivity (진입)", group: "Basic setting", inputType: "number" },
  { column: "atr_period_short", label: "SHORT ATR Period (진입)", group: "Basic setting", inputType: "number" },
  { column: "entry_checking", label: "진입 기준 신호", group: "Basic setting", inputType: "select", options: SIGNAL_CHECKING },
  { column: "hedge_checking", label: "헷지 기준 신호", group: "Basic setting", inputType: "select", options: SIGNAL_CHECKING },
  {
    column: "band_max_losscut_pct",
    label: "최대손절간격(%)",
    group: "Basic setting",
    inputType: "number",
  },
  { column: "hedge_hl_bar_count", label: "헷지/터틀 N봉 갯수", group: "Basic setting", inputType: "number" },
  { column: "close_tp_hl_bar_count", label: "익절 N봉 갯수", group: "Basic setting", inputType: "number" },
  {
    column: "entry_extreme_avg_mode",
    label: "극값 평균 진입",
    group: "Basic setting",
    inputType: "select",
    options: ENTRY_EXTREME_AVG,
  },
  { column: "band_dca_mode", label: "DCA 모드", group: "Basic setting", inputType: "select", options: BAND_DCA_MODE },
  { column: "band_dca_steps", label: "DCA 단계(JSON)", group: "Basic setting", inputType: "text" },
  { column: "entry_hold_ratio", label: "메인 보전 발동률(%)", group: "Basic setting", inputType: "number" },
  {
    column: "entry_hold_mode",
    label: "메인 보전 모드",
    group: "Basic setting",
    inputType: "hold_preserve_mode",
    options: HOLD_PRESERVE,
    pairedRoiColumn: "entry_hold_roi_pct",
    pairedSwitchColumn: "entry_hold_switch_pct",
    roiLabel: "메인 수익보전 ROI(%)",
    switchLabel: "메인 변환기준(%)",
  },
  {
    column: "entry_hold_roi_pct",
    label: "메인 수익보전 ROI(%)",
    group: "Basic setting",
    inputType: "number",
    hideInBulkPicker: true,
  },
  {
    column: "entry_hold_switch_pct",
    label: "메인 변환기준(%)",
    group: "Basic setting",
    inputType: "number",
    hideInBulkPicker: true,
  },
  { column: "hedge_hold_ratio", label: "헷지 보전 발동률(%)", group: "Basic setting", inputType: "number" },
  {
    column: "hedge_hold_mode",
    label: "헷지 보전 모드",
    group: "Basic setting",
    inputType: "hold_preserve_mode",
    options: HOLD_PRESERVE,
    pairedRoiColumn: "hedge_hold_roi_pct",
    pairedSwitchColumn: "hedge_hold_switch_pct",
    roiLabel: "헷지 수익보전 ROI(%)",
    switchLabel: "헷지 변환기준(%)",
  },
  {
    column: "hedge_hold_roi_pct",
    label: "헷지 수익보전 ROI(%)",
    group: "Basic setting",
    inputType: "number",
    hideInBulkPicker: true,
  },
  {
    column: "hedge_hold_switch_pct",
    label: "헷지 변환기준(%)",
    group: "Basic setting",
    inputType: "number",
    hideInBulkPicker: true,
  },
  { column: "hedge_out_candle", label: "헷지 정리 기준봉", group: "헷지 정리", inputType: "select", options: CANDLE },
  { column: "hedge_out_checking", label: "헷지 정리 기준 신호", group: "헷지 정리", inputType: "select", options: SIGNAL_CHECKING },
  { column: "entry_standard", label: "보조 모드", group: "Support setting", inputType: "select", options: ENTRY_STANDARD },
  { column: "ema_standard", label: "EMA 기준봉갯수", group: "Support setting", inputType: "number" },
  { column: "ema_losscut", label: "EMA 손절적용", group: "Support setting", inputType: "select", options: [{ value: "no", label: "미적용" }, { value: "apply", label: "적용" }] },
  { column: "ema_hedge_gap_ratio", label: "EMA 헷지 이격(%)", group: "Support setting", inputType: "number" },
  { column: "candle_standard", label: "보조 시간봉", group: "Support setting", inputType: "select", options: CANDLE },
  { column: "candle_type_standard", label: "보조 신호 기준", group: "Support setting", inputType: "select", options: CANDLE_TYPE },
  { column: "sensitivity_standard", label: "보조 Sensitivity", group: "Support setting", inputType: "number" },
  { column: "atr_period_standard", label: "보조 ATR Period", group: "Support setting", inputType: "number" },
  { column: "entry_standard_2nd", label: "2nd 보조 모드", group: "Support setting", inputType: "select", options: ENTRY_STANDARD },
  { column: "ema_standard_2nd", label: "2nd EMA 기준봉갯수", group: "Support setting", inputType: "number" },
  { column: "candle_standard_2nd", label: "2nd 보조 시간봉", group: "Support setting", inputType: "select", options: CANDLE },
  { column: "candle_type_standard_2nd", label: "2nd 신호 기준", group: "Support setting", inputType: "select", options: CANDLE_TYPE },
  { column: "sensitivity_standard_2nd", label: "2nd 보조 Sensitivity", group: "Support setting", inputType: "number" },
  { column: "atr_period_standard_2nd", label: "2nd 보조 ATR Period", group: "Support setting", inputType: "number" },
  { column: "close_mode", label: "단일 익절 기준", group: "익절 설정", inputType: "select", options: UT_KINPOINT },
  { column: "close_candle", label: "익절 기준봉", group: "익절 설정", inputType: "select", options: CANDLE },
  { column: "close_checking", label: "익절 기준 신호", group: "익절 설정", inputType: "select", options: SIGNAL_CHECKING },
  { column: "single_tp_continue_mode", label: "익절 후 연속 진입", group: "익절 설정", inputType: "select", options: ABLE_DISABLE },
  { column: "standard_checking", label: "보조 기준 신호", group: "익절 설정", inputType: "select", options: SIGNAL_CHECKING },
  { column: "start_ratio", label: "터틀 시작 비율(%)", group: "익절 설정", inputType: "number" },
  { column: "confirmed_ratio", label: "터틀 확정 비율(%)", group: "익절 설정", inputType: "number" },
  { column: "max_ratio", label: "터틀 최대 비율(%)", group: "익절 설정", inputType: "number" },
  { column: "leverage_info", label: "Set Leverage", group: "레버리지/진입", inputType: "number" },
  { column: "benefit_ratio", label: "최소 익절률(%)", group: "레버리지/진입", inputType: "number" },
  { column: "entry_usdt_1", label: "진입 USDT", group: "레버리지/진입", inputType: "number" },
  { column: "welfare_mode", label: "복리 모드 선택", group: "레버리지/진입", inputType: "select", options: ABLE_DISABLE },
  { column: "welfare_ratio", label: "복리 진입 비율(%)", group: "레버리지/진입", inputType: "number" },
  { column: "hedge_continue", label: "헷지 연결 포지션", group: "레버리지/진입", inputType: "select", options: HEDGE_CONTINUE },
  { column: "double_benefit", label: "더블익절설정(%)", group: "더블/종합익절", inputType: "number" },
  { column: "double_continue", label: "더블연속모드", group: "더블/종합익절", inputType: "select", options: ABLE_DISABLE },
  { column: "double_benefit_start", label: "더블익절 시작", group: "더블/종합익절", inputType: "boolean", options: ON_OFF },
  { column: "total_benefit_usdt", label: "종합 익절 셋팅(%)", group: "더블/종합익절", inputType: "number" },
  { column: "total_benefit_count", label: "종합 익절 목표 횟수", group: "더블/종합익절", inputType: "number" },
  { column: "total_current_count", label: "종합 익절 현재 횟수", group: "더블/종합익절", inputType: "number" },
  { column: "total_continue_mode", label: "종합 익절 연속 모드", group: "더블/종합익절", inputType: "select", options: ABLE_DISABLE },
  { column: "total_continue_direction", label: "연속 모드 시 진행 방향", group: "더블/종합익절", inputType: "select", options: TOTAL_CONTINUE_DIR },
  { column: "total_benefit_start", label: "종합익절 구동", group: "더블/종합익절", inputType: "boolean", options: ON_OFF },
  { column: "entry_price", label: "진입가(추적)", group: "가격/PNL 상태", inputType: "number" },
  { column: "hedge_price", label: "헷지가(추적)", group: "가격/PNL 상태", inputType: "number" },
  { column: "totalpnl", label: "RealizedPnL", group: "가격/PNL 상태", inputType: "number" },
  { column: "totalpnl_subtotal", label: "RealizedPnL 누적", group: "가격/PNL 상태", inputType: "number" },
  { column: "double_pnl", label: "더블 현재수익(USDT)", group: "가격/PNL 상태", inputType: "number" },
  { column: "current_balance", label: "현재 잔고(USDT)", group: "가격/PNL 상태", inputType: "number" },
  { column: "current_coin_clear", label: "현재 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "all_coin_clear", label: "전체 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "reset_coin_clear", label: "리셋 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "double_coin_clear", label: "더블 코인 정리", group: "정리 플래그", inputType: "boolean", options: ON_OFF },
  { column: "restrict_enabled", label: "진입 제한 사용", group: "진입 제한", inputType: "boolean", options: ON_OFF },
];

/** SetpageBand·bandAccountSettings 기준 — 관리자 일괄 수정 노출 컬럼 (순서 유지) */
const BAND_BULK_COLUMN_ORDER = [
  "uid", "symbol",
  "normal_selected", "trade_start", "restart", "current_symbol_stop", "current_symbol_cancle",
  "long_entry", "short_entry", "continue_entry", "add_position", "both_mode", "direction",
  "entry_basis", "hedge_mode", "full_mode",
  "entry_candle", "hedge_candle", "candle_type_entry", "candle_type_close",
  "sensitivity", "atr_period", "sensitivity_short", "atr_period_short",
  "entry_checking", "hedge_checking", "band_max_losscut_pct",
  "hedge_hl_bar_count", "close_tp_hl_bar_count", "entry_extreme_avg_mode", "band_dca_mode", "band_dca_steps",
  "entry_hold_ratio", "entry_hold_mode", "entry_hold_roi_pct", "entry_hold_switch_pct",
  "hedge_hold_ratio", "hedge_hold_mode", "hedge_hold_roi_pct", "hedge_hold_switch_pct",
  "hedge_out_candle", "hedge_out_checking",
  "entry_standard", "ema_standard", "ema_losscut", "ema_hedge_gap_ratio",
  "candle_standard", "candle_type_standard", "sensitivity_standard", "atr_period_standard",
  "entry_standard_2nd", "ema_standard_2nd", "candle_standard_2nd", "candle_type_standard_2nd",
  "sensitivity_standard_2nd", "atr_period_standard_2nd",
  "close_mode", "close_candle", "close_checking", "single_tp_continue_mode",
  "standard_checking", "start_ratio", "confirmed_ratio", "max_ratio",
  "leverage_info", "benefit_ratio", "entry_usdt_1", "welfare_mode", "welfare_ratio", "hedge_continue",
  "double_benefit", "double_continue", "double_benefit_start",
  "total_benefit_usdt", "total_benefit_count", "total_current_count",
  "total_continue_mode", "total_continue_direction", "total_benefit_start",
  "entry_price", "hedge_price", "totalpnl", "totalpnl_subtotal", "double_pnl", "current_balance",
  "current_coin_clear", "all_coin_clear", "reset_coin_clear", "double_coin_clear",
  "restrict_enabled",
];

const _catalogByColumn = Object.fromEntries(_BAND_FIELD_CATALOG.map((field) => [field.column, field]));

export const BAND_BULK_FIELDS = BAND_BULK_COLUMN_ORDER.map((column) => _catalogByColumn[column]).filter(Boolean);

export const BAND_FIELD_MAP = Object.fromEntries(BAND_BULK_FIELDS.map((field) => [field.column, field]));

export const BAND_BULK_GROUPS = [...new Set(BAND_BULK_FIELDS.map((field) => field.group))];

export function getBandFieldLabel(column) {
  return BAND_FIELD_MAP[column]?.label || _catalogByColumn[column]?.label || column;
}

export function getBandFieldMeta(column) {
  return (
    BAND_FIELD_MAP[column]
    || _catalogByColumn[column]
    || { column, label: column, group: "기타", inputType: "text" }
  );
}

export function formatBandDisplayValue(column, rawValue) {
  if (rawValue === null || rawValue === undefined) {
    return "NULL";
  }

  const field = getBandFieldMeta(column);
  if (!field) {
    return String(rawValue);
  }

  if (field.options) {
    const matched = field.options.find((option) => String(option.value) === String(rawValue));
    if (matched) {
      return matched.label;
    }
  }

  return String(rawValue);
}

export function getFilterOperatorsForField(column) {
  const field = getBandFieldMeta(column);
  if (!field) {
    return [
      { value: "=", label: "같음 (=)" },
      { value: "!=", label: "다름 (!=)" },
      { value: "LIKE", label: "포함 (LIKE)" },
      { value: "IN", label: "목록 (IN)" },
      { value: "IS NULL", label: "비어 있음" },
      { value: "IS NOT NULL", label: "값 있음" },
    ];
  }

  if (field.inputType === "number" || field.inputType === "escape_px") {
    return [
      { value: "=", label: "같음 (=)" },
      { value: "!=", label: "다름 (!=)" },
      { value: ">", label: "큼 (>)" },
      { value: "<", label: "작음 (<)" },
      { value: ">=", label: "이상 (>=)" },
      { value: "<=", label: "이하 (<=)" },
      { value: "IS NULL", label: "비어 있음" },
    ];
  }

  if (field.inputType === "boolean" || field.inputType === "select" || field.inputType === "hold_preserve_mode") {
    return [
      { value: "=", label: "같음 (=)" },
      { value: "!=", label: "다름 (!=)" },
      { value: "IS NULL", label: "비어 있음" },
      { value: "IS NOT NULL", label: "값 있음" },
    ];
  }

  return [
    { value: "=", label: "같음 (=)" },
    { value: "!=", label: "다름 (!=)" },
    { value: "LIKE", label: "포함 (LIKE)" },
    { value: "IN", label: "목록 (IN, 쉼표 구분)" },
    { value: "IS NULL", label: "비어 있음" },
    { value: "IS NOT NULL", label: "값 있음" },
  ];
}
